export const ALLOW_CAMERA = 'ALLOW_CAMERA';
export const DENIED_CAMERA = 'DENIED_CAMERA';

export const APPOINTMENT_DESCRIPTION = 'APPOINTMENT_DESCRIPTION';

export const WAIT_STOP_CONNECTION = 'WAIT_STOP_CONNECTION';
export const WAIT_CONNECTION = 'WAIT_CONNECTION';
export const WAITING_ROOM = 'WAITING_ROOM';
export const CLALIT_WAITING_ROOM = 'CLALIT_WAITING_ROOM';
export const RECONNECTION = 'RECONNECTION';
export const F2F_PLACEHOLDER = 'F2F_PLACEHOLDER';
